import React from 'react';
import HomeCategory from './component/HomeCategory';
import Eventexpo from './component/EventExpo';
import FreshArrivals from './component/FreshArrivals';
import OfferBanner from './component/OfferBanner';
import Herobanner from './component/Herobanner';
import MyCollections from './component/MyCollections';

const Homepage = () => {
  
  localStorage.setItem("token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjozNjMsIm5hbWUiOiJNYW50dSBTaGFybWEiLCJlbWFpbCI6Im1hbnR1QG9ic2Vzc2lvbnMuY28uaW4iLCJ1c2VyX3R5cGUiOiJjdXN0b21lciIsInVzZXJfcm9sZV9pZCI6NSwibWFuYWdlcl9pZCI6MCwicm9sZSI6ImFkbWluIiwiaWF0IjoxNzgzNjgyMjM1LCJleHAiOjE3ODYyNzQyMzV9.sn1cBknLyZtcuA8-yxwObGe2v-kZXUvLhYbo6AsrEOc");
  
 return(
    <> 
      <Herobanner/>
      <HomeCategory/>
      <Eventexpo/>
      <FreshArrivals/>
      <OfferBanner/>
      <MyCollections/>
   </>
 )
}
export default Homepage;